import type { BodyRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type AddEventParticipantBodyRequestParams =
  paths['/events/{eventId}/participants']['post']['requestBody']['content']['application/json'];
type AddEventParticipantPathRequestParams = paths['/events/{eventId}/participants']['post']['parameters']['path'];

export const addEventParticipants = async ({
  body,
  routeParams: { eventId },
}: BodyRouteParamsRequest<AddEventParticipantBodyRequestParams, AddEventParticipantPathRequestParams>) =>
  nodeApiClient.post<undefined, ApiClientResponse<undefined>>(nodeApiRoutes.events.participants.create(eventId), body);
